export default __webpack_public_path__ + "static/media/Figtree-Bold.20d002e2.ttf";